import { XeroConnectionSyncStage } from '@ankor-io/common/types/integrations/xero/types'

export const STAGE_LABELS: Record<string, string> = {
  [XeroConnectionSyncStage.LOADING_TRANSACTIONS]: 'Load Transactions',
  [XeroConnectionSyncStage.MAPPING]: 'Mapping',
  [XeroConnectionSyncStage.SYNCING_TRANSACTIONS]: 'Sync Transactions',
  [XeroConnectionSyncStage.SYNCING_ATTACHMENTS]: 'Sync Attachments',
}

export const STAGE_ORDER: XeroConnectionSyncStage[] = [
  XeroConnectionSyncStage.LOADING_TRANSACTIONS,
  XeroConnectionSyncStage.MAPPING,
  XeroConnectionSyncStage.SYNCING_TRANSACTIONS,
  XeroConnectionSyncStage.SYNCING_ATTACHMENTS,
]
